<div class="risk-widget-list">
  <app-risk-widget (onSelect)="onSelect()" [config]="riskAssessmentConfig"></app-risk-widget>
  <app-risk-widget (onSelect)="onSelect()" [config]="remainingRiskConfig"></app-risk-widget>
</div>
